let _this , searchParams = {
  sortName: "createTime",
  sortType: 1,
  page: 1,
  perPage: 10,
  isRecurringReport : false,
  enabledPaging:true
}
export default {
  data() {
    return {
      deleteModal: false,
      titleDate: [
        {title: 'Report Name', key: 'reportName', width: 200 , render: (h, params) => {
            return h('utm-ellipsis', {
              props: {
                content: params.row['reportName'],
                transfer: true
              }
            })
          }},
        {title: 'Report Format', slot: 'type', minWidth: 180},
        {title: 'Report Type', slot: 'permissionType', minWidth: 180},
        {title: 'Generated Time', slot: 'createTime', minWidth: 200,sortable:'custom', sortType:'desc'},
        {title: 'Remaining Time', slot: 'remainingTime', minWidth: 180},
        {title: 'Status', slot: 'status', minWidth: 150},
        {title: 'Operator', key: 'operatorName', minWidth: 100},
        {title: 'Operation', slot: 'operation', minWidth: 150, align: 'left', fixed: 'right'}
      ],
      searchParams: JSON.parse(JSON.stringify(searchParams)),
      tableData: [],
      generateStatus:{'0':'Generating', '1':'Generated', '2':'Failed', '3':'Abnormal'},
      downloadModal:false,
      downloadInfo:{},
      deleteIds:[],
      isIncludeVideo:false,
      isIncludeAttachment : false,
      isTableLoading:true,
      timer:null,
      countdownLine :null,
      isLoadingCount:0,
    }
  },
  mounted() {
    _this = this;
    _this.getRecordList(true);
    _this.timer = setInterval(() => {
      _this.getLostTime();
    },5000);
  },

  beforeDestroy(){
    _this = this;
    clearInterval(_this.timer);
    clearInterval(_this.countdownLine);
  },

  methods: {
    //获取数据
    getRecordList: function (isCount) {
      if(isCount){
        _this.isTableLoading = true;
        _this.$set(_this,'tableData',[]);
      }
      _this.$ajax.post('GenerateReport/Paging', _this.searchParams,{headers: {noLoading: true}}).then(function (res) {
        if (res.data.success) {
          _this.tableData = res.data.data.items;
          _this.tableData.forEach(item=>{
            _this.$set(item,'isLoading',false);
          })
          let totalSearch = {
            sortName: "createTime",
            sortType: 1,
            isRecurringReport : false,
            enabledPaging:false
          }
          _this.$ajax.post('GenerateReport/Paging', totalSearch,{headers: {noLoading: true}}).then(res=>{
            _this.isLoadingCount = res.data.data.items.filter(item=>{return item.status === 0}).length;
            if(_this.isLoadingCount > 0) {
              _this.getLostTime();
            }
          })
        } else {
          _this.$set(_this,'tableData',[]);
        }
        _this.isTableLoading = false;
      });
    },

    //获取生成中的报表剩余时间
    getLostTime:function(callback){
      let totalSearch = {
        sortName: "createTime",
        sortType: 1,
        isRecurringReport : false,
        enabledPaging:false
      }
      _this.$ajax.post('GenerateReport/GetRemainingTime',totalSearch,{headers:{noLoading:true}}).then(res=>{
        if(res.data.success){
          if(callback){
            callback()
          }
          let array = res.data.data.items;
          _this.tableData.forEach(item=>{
            array.forEach(it=>{
              if(item.id === it.id){
                item.remainingTime = it.remainingTime;
              }
            })
          })
          if(res.data.data.itemCount !== _this.isLoadingCount){
            _this.getRecordList(false);
          }
        }
        _this.setCountdown();
      })
    },
    /*计算倒计时*/
    setCountdown:function(){
      clearInterval(_this.countdownLine);
      _this.countdownLine = setInterval(() => {
        _this.tableData.forEach(item=>{
        item.remainingTime =  item.remainingTime - 1000
        })
      },1000);
    },

    // 列表排序
    sortTable: function (data) {
      this.shareApi.sortTable(this, data, this.getRecordList(true), 'utmTable');
    },
    deleteRecord: function (id) {
      _this.deleteIds = [id]
      _this.deleteModal = true;
    },
    //确认批量删除
    confirmDelete: function () {
      this.$ajax.post('GenerateReport/Delete',this.deleteIds).then(function (res) {
        if (res.data.success) {
          _this.messageNotice('success',3);
          _this.deleteModal = false;
          _this.getRecordList(true);
        }
      })
    },
    //下载当前选择的报表
    download: function (data) {
      this.isIncludeAttachment = data.includeAttachment;
      this.isIncludeVideo = data.exportVideo;
      this.downloadInfo = {
        name:data.reportName,
        //reportFormat:data.reportFormat,
        formats:[data.reportFormat],
        id:data.id,
        password:'',
        needEncrypt:false,
        includeAttachment:false,
        includeVideo:false
      };
      this.downloadModal = true;
    },
    confirmDownload:function () {
      for (const item of _this.tableData) {
        if(_this.downloadInfo.id === item.id){
            _this.$set(item,'isLoading',true)
          break
        }
      }
      let subData = JSON.parse(JSON.stringify(this.downloadInfo));
      if(subData.password || subData.password === 0){
        subData.needEncrypt = true;
      }
      delete subData.name;
      delete subData.type;
      this.$ajax.post('GenerateReport/Download',subData,{headers: {noLoading: true},responseType:"blob",}).then(function (res) {
        const blob = res.data;
        let fileName = _this.downloadInfo.name + "_"+ new Date().getTime() + ".zip";
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onload = (e) => {
          const a = document.createElement('a');
          a.download = fileName;
          a.href = e.target.result;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        };
        
        for (const item of _this.tableData) {
          if(_this.downloadInfo.id === item.id){
            setTimeout(() => {
              _this.$set(item,'isLoading',false)
            }, 500);
            break
          }
        }
        _this.downloadModal = false;
      })
    },
    sendEmail:function (id) {
      eventBus.$emit('forwardEmail',id);
    }
  }
}



// WEBPACK FOOTER //
// ./src/admin/components/downloadCenters/manual.js